export default __webpack_public_path__ + "static/NotoSans-ThinItalic-5adb21728b5238d16b95c3cb2d0ff415.ttf";